import doRequest from "api/utils/doRequest";
import { preventRefetch } from "api/utils/preventRefetch";
import gql from "graphql-tag";
import { useQuery } from "react-query";

const getChannel = gql`
  query getChannel($channelId: Int!) {
    getChannel(channelId: $channelId) {
      id
      name
      companyName
      shopName
      defaultShopLanguage
      shopLanguages
      domain
      companyExercises
      coachExercises
      plan
      status
      trialEndDate
      possiblePlanDowngrades
      lockDate
      shopType
      shop
      app {
        name
        android {
          id
          downloadUrl
        }
        ios {
          id
          downloadUrl
        }
      }
      payment {
        status
        nextPayment {
          date
          amount
          currency
          settled
        }
        paymentMethod {
          type
          card {
            type
            stripePaymentMethodId
            netsSubscriptionId
            brand
            expireMonth
            expireYear
            cardNumber
          }
        }
      }
      shopPayments {
        enabled
        iapEnabled
        paymentSolution
        stripeAccountId
        stripeTaxCalculation
        stripeConnectUrl
        enabledCurrencies {
          currency
          default
        }
        enabledTaxRates
        stripeTaxCodes {
          code
          name
        }
      }
      address {
        streetLine1
        streetLine2
        postalNumber
        city
        country
        status {
          status
          lastUpdate
        }
      }
      invoiceEmail
      orgNr
      vatNr
      customerCount {
        currentClientCount
        maxCustomerCount
      }
      createdAt
    }
  }
`;

export function useGetChannel(channelId) {
  return useQuery(
    ["getChannel", { channelId }],
    async () =>
      await doRequest(
        {
          query: getChannel,
          variables: {
            channelId,
          },
        },
        "data.getChannel"
      ),
    { ...preventRefetch, retry: 2, enabled: Boolean(channelId) }
  );
}
